/**
 * Fetch User Paths API
 * GET /api/learning-paths/assigned
 * Fetches learning paths assigned to the current user
 */

import axiosInstance from "../axiosInstance";

/**
 * Backend response structure
 */
interface BackendUserPathItem {
  enrollmentId: number;
  pathId: number;
  pathName: string;
  pathDescription?: string;
  completionPercentage: number;
  enrolledAt: string;
  completedAt?: string | null;
  dueDate?: string;
  totalItems: number;
  completedItems: number;
  currentItemName?: string;
  status: string;
  /** Lifecycle status of the underlying path ('draft' | 'published'); used to flag paths that are no longer published. */
  pathStatus?: string;
}

interface BackendResponse {
  data: BackendUserPathItem[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

/**
 * Frontend response type
 */
export interface FetchUserPathsResponse {
  paths: Array<{
    enrollmentId: number;
    pathId: number;
    pathName: string;
    pathDescription?: string;
    completionPercentage: number;
    enrolledAt: string;
    completedAt?: string | null;
    dueDate?: string;
    totalItems: number;
    completedItems: number;
    currentItemName?: string;
    status: string;
    pathStatus?: string;
  }>;
}

/**
 * Fetches learning paths assigned to the current user
 * @returns Array of learning paths with progress
 */
export const fetchUserPaths = async (): Promise<FetchUserPathsResponse> => {
  const response = await axiosInstance.get<BackendResponse>(
    `/api/learning-paths/assigned`,
  );

  // Transform backend response to frontend format
  return {
    paths: response.data.data,
  };
};
